<div class="doc-sign-wrapper" [ngClass]="docType.id">
  <!-- SIGNATURES FORM -->
  <div class="doc-sign-form-wrapper">
    <!-- form -->
    <form [formGroup]="form" class="doc-form" *ngIf="form">
      <div *ngIf="docType.dates">
        <!-- begin -->
        <app-form-input-date [field]="'startDate'" [formControl]="f['begin']" formControlName="begin"></app-form-input-date>
        <!-- end -->
        <app-form-input-date [field]="'endDate'" [formControl]="f['end']" formControlName="end"></app-form-input-date>
      </div>
      <!-- name -->
      <app-form-input-text [field]="'name-document'" [formControl]="f['name']" formControlName="name"></app-form-input-text>
      <!-- description -->
      <app-form-input-text-area [field]="'description-document'" [formControl]="f['description']" 
        formControlName="description" [rows]="3"></app-form-input-text-area>
      <!-- attendanceComment -->
      <app-form-input-text-area [field]="'attendance-comments'" [formControl]="f['attendanceComment']" 
        formControlName="attendanceComment" [rows]="3" *ngIf="docType.attendanceComment"></app-form-input-text-area>
      <div *ngIf="docType.patientInfo">
        <!-- patientName -->
        <app-form-input-text [field]="'patient'" [formControl]="f['patientName']" formControlName="patientName"></app-form-input-text>
        <!-- patientTaxcode -->
        <app-form-input-text [field]="'taxcode'" [formControl]="f['patientTaxcode']" formControlName="patientTaxcode"></app-form-input-text>
      </div>
      <!-- patientComments -->
      <app-form-input-text-area [field]="'comments-patient'" [formControl]="f['patientComments']" formControlName="patientComments"
        [rows]="3" *ngIf="f['docType'].value?.comments"></app-form-input-text-area>
      <!-- professional -->
      <app-form-input-dropdown [options]="professionals" [optionsField]="'givenname'" [appendTo]="'body'" [clearable]="true"
        [filter]="true" [field]="'professionalName'" [formControl]="f['professional']" formControlName="professional"
        [placeholder]="'field.professional' | translate" *ngIf="f['docType'].value?.signatures === 2"></app-form-input-dropdown>
      <!-- professionalTaxcode -->
      <app-form-input-text [field]="'membership-number'" [formControl]="f['professionalTaxcode']" formControlName="professionalTaxcode"
        *ngIf="f['docType'].value?.signatures === 2"></app-form-input-text>
      <!-- attendance -->
      <div class="attendance" *ngIf="docType.attendance">
        <label [innerHTML]="'field.companion-proof' | translate" class="input-label"></label>
        <p-selectbutton [options]="attendanceOptions" formControlName="attendance" optionLabel="name" optionValue="value" [allowEmpty]="false" />
      </div>
      <div *ngIf="this.f['attendance'].value">
        <!-- attendanceName -->
        <app-form-input-text [field]="'companion-name'" [formControl]="f['attendanceName']" formControlName="attendanceName"></app-form-input-text>
        <!-- attendanceTaxcode -->
        <app-form-input-text [field]="'companion-taxcode'" [formControl]="f['attendanceTaxcode']" formControlName="attendanceTaxcode"></app-form-input-text>
      </div>
      <!-- signatures imgs -->
      <div class="signatures" *ngIf="signatureA || signatureB">
        <div *ngIf="signatureA">
          <span>{{ 'field.patient' | translate }}</span>
          <img [src]="signatureA" alt="signatureA">
        </div>
        <div *ngIf="signatureB">
          <span>{{ 'field.professional' | translate }}</span>
          <img [src]="signatureB" alt="signatureB">
        </div>
      </div>
      <!-- signature A -->
      <app-signature (acceptSignatureEvent)="saveSignatureA($event)" 
        [label]="('field.signature-patient' | translate) + ': ' + patient.givenname"
        *ngIf="docType.signatures && activeSignature === 'A'"></app-signature>
      <!-- signature B -->
      <app-signature (acceptSignatureEvent)="saveSignatureB($event)" [label]="'field.signature-professional' | translate"
        *ngIf="activeSignature === 'B'"></app-signature>
      <!-- buttons -->
      <div class="buttons">
        <p-button [label]="'button.cancel' | translate" severity="secondary" (click)="cancelSign()"/>
        <p-button [label]="'button.generate-document' | translate" severity="contrast" (click)="sign()"/>
      </div>
    </form>
  </div>
  <!-- DOC PREVIEW -->
   <div class="doc-preview-wrapper">
    <iframe
      *ngIf="pdfUrl"
      [src]="pdfUrl"
      width="100%"
      height="800px"
      style="border: none;"
    ></iframe>
   </div>
</div>